import { ZegoExpressEngine } from "zego-express-engine-webrtc";
import { Zeego_server_url, Zeego_AppId } from "../../src/config/config_local";
import { AndroidPermissions } from "@ionic-native/android-permissions";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { call } from "../../src/config/axios";
import Calling from "./Calling"
import { isPlatform } from "@ionic/react";
import {
  FaMicrophone,
  FaVideo,
  FaVideoSlash,
  FaMicrophoneSlash,
} from "react-icons/fa";
import { BsChatDots } from "react-icons/bs";
import { MdCallEnd, MdPerson } from "react-icons/md";
import { IonModal } from "@ionic/react";
import { IoCloseSharp } from "react-icons/io5";
import ReactDOMServer from "react-dom/server";
import { LuSendHorizonal } from "react-icons/lu";

import {  SIGNAL_RECORDING } from "../../src/config/endpoints";
import "./styles.css";


const GroupCall = (props) => {
  const dispatch = useDispatch();
  const sendText = useRef(null);
  const localstreamRef = useRef(null);
  const zg = useRef(null);
  const history = useHistory();
  const [isJoined, setIsJoined] = useState(false);
  const [localStream, setLocalStream] = useState(null);
  const [videoElements, setVideoElements] = useState([]);
  const [messageList, setMessageList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [videoElementIds, setVideoElementIds] = useState([]);
  const [muteAudio, setMuteAudio] = useState(false);
  const [muteVideo, setMuteVideo] = useState(false);
  const [localVideoClass, setLocalVideoClass] = useState("remote-video");
  const [remoteVideoClass, setremoteVideoClass] = useState("remote-video");
  const [remoteStreamId, setRemoteStreamId] = useState(null);
  const [chatPopupOpen, setChatPopupOpen] = useState(false);
  const isAdminCreated = localStorage.getItem("isAdminMeeting") === "true";
  
  useEffect(() => {
    const initZegoExpressEngine = async () => {
      const App_Id = Zeego_AppId;
      const Server_url = Zeego_server_url;
      zg.current = new ZegoExpressEngine(App_Id, Server_url);
      initEvent();
      createRoom();
    };
    initZegoExpressEngine();
 
}, []);

const StreamItem = ({ user, callType }) => {
  const videoRef = React.useRef();

  React.useEffect(() => {
    if (videoRef.current && user.stream) {
      videoRef.current.srcObject = user.stream;
    }
  }, [user.stream]);

  return (
    <div
      id={user.streamId}
      className={userList.length > 1 ? "fourUsers" : "twousers"}
    >
      <span className="belParameter">
        <MdPerson /> {user.userName}
      </span>

      {callType !== "audio-video" ? (
        <div className="circleOuter">
          <div className="circleMuted">
            <div className="soundRing"></div>
            <span className="textCircle">{user.userName.charAt(0).toUpperCase()}</span>
          </div>
        </div>
      ) : null}

      <div id={user.userID} className="audVidMute">
        <div className="mutAud"><FaMicrophone /></div>
        {callType === "audio-video" && (
          <div className="mutVid"><FaVideo /></div>
        )}
      </div>

      {callType === "audio-video" ? (
        <video ref={videoRef} autoPlay playsInline muted={false} />
      ) : (
        <audio ref={videoRef} autoPlay />
      )}
    </div>
  );
};
 


  const requestMicrophonePermission = async () => {
    if (isPlatform("ios")) {
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true });
        console.log("Microphone permission granted");
      } catch (err) {
        console.error("Microphone permission not granted", err);
      }
    }
  };


  useEffect(() => {
    const videoContainer = document.querySelector(".video-container");

    const hasVideoElements = videoElementIds.length > 0;
    console.log("hasVideoElements", hasVideoElements);
    if (videoElementIds.length < 1) {
      setLocalVideoClass("local-stream-video");
    } else if (videoElementIds.length === 1) {
      setLocalVideoClass("small-video");
      videoElementIds.forEach(function (id) {
        var element = document.getElementById(id);
        if (element) {
          element.classList.remove("medium-video");
          element.classList.add("remote-video");
        }
      });
    } else if (videoElementIds.length > 1) {
      setLocalVideoClass("medium-video");
      videoElementIds.forEach(function (id) {
        var element = document.getElementById(id);
        if (element) {
          element.classList.remove("remote-video");
          element.classList.add("medium-video");
        }
      });

      if (videoContainer) {
        const videoElements = videoContainer.querySelectorAll("video");

        videoElements.forEach((videoElement) => {
          videoElement.classList.remove("main-video");
          //videoElement.classList.add('medium-video');
        });
      }
    }
  }, [videoElementIds]);

  const removeVideoElementId = (idToRemove) => {
    setVideoElementIds((prevIds) => prevIds.filter((id) => id !== idToRemove));
  };
  const addVideoElementId = (id) => {
    setVideoElementIds((prevIds) => [...prevIds, id]);
  };

  let userName = "Default User";
  let callType = "audio-video";
    const onGoingMeetingData = localStorage.getItem("on_going_meeting");

  if (onGoingMeetingData) {
    const meetingObject = JSON.parse(onGoingMeetingData);
    userName = meetingObject.user_name;
    callType = meetingObject.videoType;
  }

  const RoomId = window.location.pathname.split("/").slice(-1)?.[0];
  const register_Id = localStorage.getItem("creator_id");
  const userID = localStorage.getItem("register_id");
  const capitalizedUserName = userName.charAt(0).toUpperCase();
  const streamID = Array(9)
    .fill()
    .map(() => ((Math.random() * 36) | 0).toString(36))
    .join("");

    


  



  const callTokenApi = (paramsObj, flag) => {
    
      paramsObj["userType"] = "user";
      paramsObj["userId"] = localStorage.getItem("register_id");
    
    return call(SIGNAL_RECORDING, paramsObj)
      .then((res) => {
        console.log(res, "api response");
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  };

  const createRoom = async () => {
    try {
      let data = "";
      
      const paramObj = {
        meeting_id: RoomId,
        register_id: register_Id,
        type: "generate_token",
      };
      data = await callTokenApi(paramObj, "generate_token");
      if (
        !AndroidPermissions.hasPermission(AndroidPermissions.PERMISSION.CAMERA)
      ) {
        await AndroidPermissions.requestPermission(
          AndroidPermissions.PERMISSION.CAMERA
        );
      }
      if (
        !AndroidPermissions.hasPermission(
          AndroidPermissions.PERMISSION.RECORD_AUDIO
        )
      ) {
        await AndroidPermissions.requestPermission(
          AndroidPermissions.PERMISSION.RECORD_AUDIO
        );
      }

      requestMicrophonePermission();

      
      if (
        !AndroidPermissions.hasPermission(
          AndroidPermissions.PERMISSION.RECORD_AUDIO
        )
      ) {
        await AndroidPermissions.requestPermission(
          AndroidPermissions.PERMISSION.RECORD_AUDIO
        );
      }

      requestMicrophonePermission();

     
      const result = await zg.current.loginRoom(
        RoomId,
        data.token,
        { userID, userName },
        { userUpdate: true }
      );
      console.log("result", result);
      const deviceInfo = await zg.current.enumDevices();
      console.log("deviceInfo", deviceInfo);
      if (!localstreamRef.current) {
        setLocalStream(streamID);
        if (callType === "audio-video") {
          localstreamRef.current = await zg.current.createZegoStream({
            camera: {
              audioInput: deviceInfo.microphones[0].deviceID,
              videoInput: deviceInfo.cameras[0].deviceID,
              video: true,
              audio: true,
            },
          });
          localstreamRef.current.playVideo(
            document.querySelector("#local-video")
          );
        } else {
          localstreamRef.current = await zg.current.createZegoStream({
            camera: { audio: true, video: false },
          });
        }

        zg.current.startPublishingStream(streamID, localstreamRef.current);
        zg.current.setSoundLevelDelegate(true, 1000);

        
      }

      setRemoteStreamId(streamID);
    } catch (error) {
      const stopRecordParamsObj = {
        meeting_id: RoomId,
        type: "stopRecord",
        register_id: localStorage.getItem("register_id"),
      };
      if (isAdminCreated) {
        await callTokenApi(stopRecordParamsObj, "stopRecord");
      }
      console.error("Error creating room:", error);
    }
  };

   const initEvent = () => {
    zg.current.on(
      "roomStateUpdate",
      (roomID, state, errorCode, extendedData) => {
        if (state === "DISCONNECTED") {
          console.log("DISCONNECTED");
        }
        if (state === "CONNECTING") {
          console.log("CONNECTING");
        }
        if (state === "CONNECTED") {
          console.log("CONNECTED");
        }
      }
    );
    zg.current.on("IMRecvBroadcastMessage", (roomID, chatData) => {
      console.log("IMRecvBroadcastMessage", roomID, chatData);
      let message = {
        ID: "zego" + chatData[0].fromUser.userID + chatData[0].sendTime,
        name: chatData[0].fromUser.userName,
        time: moment(chatData[0].sendTime).format("hh:mm A"),
        content: chatData[0].message,
        type: "received",
      };
      setMessageList((prevMessages) => [...prevMessages, message]);
    });

    zg.current.on("roomUserUpdate", (roomID, updateType, userList) => {
      console.log("roomUserUpdate", roomID);
      if (updateType === "ADD") {
        console.log("roomUserUpdate", userList);
      } else if (updateType == "DELETE") {
        console.log("roomUserUpdate", userList);
      }
    });
    zg.current.on("publisherStateUpdate", (result) => {
      //alert('publisherStateUpdate',result.streamID, result.state)
    });

    zg.current.on("remoteCameraStatusUpdate", (streamID, status) => {
      if (callType === "audio-video") {
        const divElement = document.getElementById(streamID);
        if (divElement) {
          let iconElement;
          let videoElement = divElement.querySelector("video");
          if (status === "MUTE") {
            iconElement = document.createElement("span");
            iconElement.className = "icon-dynamic";
            var faVideoElement = React.createElement(FaVideoSlash);
            var htmlString = ReactDOMServer.renderToString(faVideoElement);
            iconElement.innerHTML = htmlString;
            const belParameterElement =
              divElement.querySelector(".bel-parameter");
            const text = belParameterElement.textContent.trim();
            const capitalizedText = text.charAt(0).toUpperCase();
            videoElement.style.display = "none";
            divElement.classList.add("mute-active");
            const circleOuter = document.createElement("div");
            circleOuter.className = "circle-outer";
            circleOuter.style.height = '100%';
            const circleMuted = document.createElement("div");
            circleMuted.className = "circle-muted";

            const textCircle = document.createElement("span");
            textCircle.className = "text-circle";
            textCircle.textContent = capitalizedText;

            circleMuted.appendChild(textCircle);
            circleOuter.appendChild(circleMuted);

            divElement.appendChild(circleOuter);
          } else {
            iconElement = document.createElement("span");
            iconElement.className = "icon-dynamic";
            var faVideoElement = React.createElement(FaVideo);
            var htmlString = ReactDOMServer.renderToString(faVideoElement);
            iconElement.innerHTML = htmlString;
            videoElement.style.display = "block";
            divElement.classList.remove("mute-active");
            const circleOuter = divElement.querySelector(".circle-outer");
            if (circleOuter) {
              circleOuter.remove();
            }
          }

          const mutVidDiv = divElement.querySelector(".mut-vid");
          if (mutVidDiv) {
            mutVidDiv.innerHTML = "";
            mutVidDiv.appendChild(iconElement);
          }
        }
      }
    });
    zg.current.on("remoteMicStatusUpdate", (streamID, status) => {
      console.log("remoteMicStatusUpdate", streamID, status);
      const divElement = document.getElementById(streamID);
      if (divElement) {
        let iconElement;
        if (status === "MUTE") {
          iconElement = document.createElement("span");
          iconElement.className = "icon-dynamic";
          var faVideoElement = React.createElement(FaMicrophoneSlash);
          var htmlString = ReactDOMServer.renderToString(faVideoElement);
          iconElement.innerHTML = htmlString;
        } else {
          iconElement = document.createElement("span");
          iconElement.className = "icon-dynamic";
          var faVideoElement = React.createElement(FaMicrophone);
          var htmlString = ReactDOMServer.renderToString(faVideoElement);
          iconElement.innerHTML = htmlString;
        }

        const mutVidDiv = divElement.querySelector(".mut-aud");
        if (mutVidDiv) {
          mutVidDiv.innerHTML = "";
          mutVidDiv.appendChild(iconElement);
        }
      }
    });
    zg.current.on("videoMuteState", (result) => {
      //alert('videoMuteState', result)
    });
    zg.current.on("playerStateUpdate", (result) => {
      var state = result["state"];
      var streamID = result["streamID"];
      var errorCode = result["errorCode"];
      var extendedData = result["extendedData"];
      // alert('player state update', state)
    });
    zg.current.on(
      "roomStreamUpdate",
      async (roomID, updateType, streamList, extendedData) => {
        if (updateType == "ADD") {
          console.log("roomStreamUpdate", streamList);
          streamList = streamList.filter(
            (stream) => stream.user.userID !== userID
          );
          if (callType === "hide") {
            if (!isAdminCreated) {
              streamList = streamList.filter(
                (stream) => stream.user.userID === register_Id
              );
            }
          }
          const newvideoElement = streamList.map((stream, index) => {
            const newRef = React.createRef();
            addVideoElementId(stream.streamID);
            (async () => {
              try {
                const remoteStream = await zg.current.startPlayingStream(
                  stream.streamID
                );
                const data = {
                  roomID: roomID,
                  updateType: updateType,
                  streamId: stream.streamID,
                  stream: remoteStream,
                  user: stream.user,
                  userID: stream.user.userID,
                  userName: stream.user.userName,
                  micMute: false,
                  camMute: false,
                };
                setUserList((prevUsers) => [...prevUsers, data]);

                let className =
                  videoElementIds.length < 1
                    ? "remote-video-1"
                    : "medium-video";

                setremoteVideoClass(className);
                const videoElement = newRef.current;
                if (videoElement && remoteStream) {
                  videoElement.srcObject = remoteStream;
                  videoElement.muted = false;
                  videoElement.className = "main-video";
                }
                // props.userJoin(userList);
              } catch (error) {
                console.error("Error starting to play the stream:", error);
              }
            })();
            return (
              <div id={stream.streamID} className={remoteVideoClass}>
                <span className="bel-parameter">
                  
                  <MdPerson /> {stream.user.userName}
                </span>
                {callType !== "audio-video" && (
                  <div className="circle-outer">
                    <div className="circle-muted">
                      <span className="text-circle">
                        {stream.user.userName.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  </div>
                )}
                <div id={stream.user.id} className="aud-vid-mute">
                  <div className={`mut-aud`}>
                    <FaMicrophone />
                  </div>

                  {callType === "audio-video" && (
                    <div className={`mut-vid`}>
                      <FaVideo />
                    </div>
                  )}
                </div>
                {callType === "audio-video" ? (
                  <video key={index} ref={newRef} autoPlay playsInline />
                ) : (
                  <audio key={index} ref={newRef} autoPlay />
                )}
              </div>
            );
          });
          setVideoElements((prevElements) => [
            ...prevElements,
            ...newvideoElement,
          ]);
        } else if (updateType == "DELETE") {
          streamList.map(async (stream, index) => {
            await zg.current.stopPlayingStream(stream.streamID);
            setUserList((prevUsers) =>
              prevUsers.filter((user) => user.streamId !== stream.streamID)
            );
            // props.userJoin(userList);
            const videoElement = document.getElementById(stream.streamID);
            if (videoElement) {
              videoElement.parentNode.removeChild(videoElement);
            }
            removeVideoElementId(stream.streamID);
          });
        }
      }
    );
    zg.current.on(
      "roomStateChanged",
      async (roomID, reason, streamList, extendedData) => {
        console.log("roomStateChanged", reason);
        if (reason == "LOGINING") {
        } else if (reason == "LOGINED") {
        } else if (reason == "LOGIN_FAILED") {
        } else if (reason == "RECONNECTING") {
          // Reconnecting.
        } else if (reason == "RECONNECTED") {
          // Reconnection successful.
        } else if (reason == "RECONNECT_FAILED") {
          // Reconnection failed.
        } else if (reason == "KICKOUT") {
          // Kicked out of the room.
          
          await zg.current.logoutRoom(RoomId);
          await zg.current.stopPublishingStream(localStream);
          await zg.current.destroyStream(localstreamRef.current);
          localStorage.removeItem("on_going_meeting")
          setIsJoined(false);
           history.push("/meetings/upcoming");
          window.location.reload();
        } else if (reason == "LOGOUT") {
          // Logout successful.
        } else if (reason == "LOGOUT_FAILED") {
          // Logout failed.
        }
      }
    );
    zg.current.on("soundLevelUpdate", (streamList) => {
      console.log("soundLevelUpdate", streamList);
      streamList.forEach((stream) => {
        if (stream.type === "push" && !muteAudio) {
          var soundLevelElement = document.getElementById("local-circle");
          if (soundLevelElement) {
            var soundLevel = Math.round(stream.soundLevel);
            var boxShadowSize = soundLevel * 10 + "px";
            soundLevelElement.style.boxShadow = `0px 0px ${boxShadowSize} 0px #1475e3`;
            setTimeout(function () {
              soundLevelElement.style.boxShadow = "none";
            }, 2000);
          }

          var streamDiv = document.getElementById("local-video");

          if (streamDiv && stream.soundLevel > 0) {
            streamDiv.style.border = "3px solid #1475e3";
            streamDiv.style.boxShadow = "0px 0px 10px 0px blue";
            setTimeout(function () {
              streamDiv.style.boxShadow = "none";
              streamDiv.style.border = "none";
            }, 3000);
          }
        }
        if (stream.type === "pull") {
          var soundLevelElement = document.getElementById(stream.streamID);
          if (soundLevelElement) {
            var circleMutedElement =
              soundLevelElement.querySelector(".circle-muted");
            if (circleMutedElement) {
              var soundLevel = Math.round(stream.soundLevel);
              var boxShadowSize = soundLevel * 10 + "px";
              circleMutedElement.style.boxShadow = `0px 0px ${boxShadowSize} 0px #1475e3`;
              setTimeout(function () {
                circleMutedElement.style.boxShadow = "none";
              }, 2000);
            }
          }
          var streamDiv = document.getElementById(stream.streamID);

          if (streamDiv && stream.soundLevel > 0) {
            streamDiv.style.border = "3px solid  #1475e3";
            streamDiv.style.boxShadow = "0px 0px 10px 0px #1475e3";
            setTimeout(function () {
              streamDiv.style.boxShadow = "none";
              streamDiv.style.border = "none";
            }, 2000);
          }
        }
      });
    });
  };
  useEffect(() => {
    if (props.mute) {
      console.log("muteVideo", props.mute);
      muteRemoteCam(props.mute.streamId, props.mute.mute);
    }
  }, [props.mute]);
  const muteRemoteCam = async (streamID, mute) => {
    try {
      await zg.current.mutePlayStreamVideo(streamID, mute);
    } catch (error) {
      console.error("Error mute remote stream:", error);
    }
  };

  const sendMessage = async () => {
    const text = sendText.current.value;
    if (text) {
      try {
        const isSent = await zg.current.sendBroadcastMessage(RoomId, text);
        sendText.current.value = "";
        const message = {
          ID: "zego" + userID + Date.now(),
          name: userName,
          time: moment().format("hh:mm A"),
          content: text,
          type: "sent",
        };
        setMessageList((prevMessages) => [...prevMessages, message]);
        console.log(">>> sendMsg success,", isSent);
      } catch (error) {
        console.log(">>> sendMsg, error:", error);
      }
    }
  };

  
  const dropCall = async () => {
    try {
      await zg.current.logoutRoom(RoomId);
      await zg.current.stopPublishingStream(localStream);
      await zg.current.destroyStream(localstreamRef.current);
      localStorage.removeItem("on_going_meeting")
      setIsJoined(false);
      history.push("/meetings/upcoming");
      
      window.location.reload();
    } catch (error) {
      console.error("Error dropping the call:", error);
      localStorage.removeItem("on_going_meeting")
      setIsJoined(false);
      history.push("/meetings/upcoming");
    }
  };

  const openChat = () => {
    var footer = document.getElementById("callFooter");
    var videoGroup = document.getElementById("videoGroup");
    var chatBox = document.getElementById("chatBox");
    var chat = document.getElementById("chat-btn");
    if (chatBox.style.display === "block") {
      chatBox.style.display = "none";
      chat.classList.remove("active-chat");
      setChatPopupOpen(false);
    } else {
      chatBox.style.display = "block";
      chat.classList.add("active-chat");
      setChatPopupOpen(true);
    }
    footer.style.height = chatBox.style.display === "block" ? "13vh" : "13vh";
    videoGroup.style.height =
      chatBox.style.display === "block" ? "70vh" : "70vh";
  };
  const muteMicro = () => {
    if (localStream) {
      if (callType === "audio-video") {
        zg.current.muteMicrophone(!muteAudio);
        setMuteAudio(!muteAudio);
      } else {
        zg.current.muteMicrophone(!muteAudio);

        setMuteAudio(!muteAudio);
      }
    }
  };
  const muteCam = async () => {
    if (localstreamRef.current) {
      const deviceInfo = await zg.current.enumDevices();

      try {
        if (muteVideo) {
          zg.current.mutePublishStreamVideo(localstreamRef.current, false);
        } else {
          zg.current.mutePublishStreamVideo(localstreamRef.current, true);
        }
      } catch (error) {
        console.error("Error unmute video:", error);
      }

      setMuteVideo(!muteVideo);
    }
  };

  useEffect(()  => {
    if (onGoingMeetingData) {
      const meetingObject1 = JSON.parse(onGoingMeetingData);
  
      // Delay execution to ensure localStream is ready
      const timeout = setTimeout(() => {
        if (localStream) {
          // Handle microphone
          if (meetingObject1.micro === false) {
            console.log(meetingObject1.micro, 'meetingObject1');
  
            if (callType === "audio-video") {
              zg.current.muteMicrophone(!muteAudio);
              setMuteAudio(!muteAudio);
            } else {
              zg.current.muteMicrophone(!muteAudio);
              setMuteAudio(!muteAudio);
            }
          }
  
          // Handle camera
          if (meetingObject1.camera === false) {
            if (localstreamRef.current) {
              const deviceInfo =  zg.current.enumDevices();
        
              try {
                if (muteVideo) {
                  zg.current.mutePublishStreamVideo(localstreamRef.current, false);
                } else {
                  zg.current.mutePublishStreamVideo(localstreamRef.current, true);
                }
              } catch (error) {
                console.error("Error unmute video:", error);
              }
        
              setMuteVideo(!muteVideo);
            }
          }
        }
      }, 1000); // Adjust timeout as needed
  
      return () => clearTimeout(timeout); // Cleanup timeout on unmount or re-run
    }
  }, [onGoingMeetingData, localStream,localstreamRef.current]);
 
   const changeClasses = () => {
    if (videoElementIds.length === 1) {
      let localVideoClassvar =
        localVideoClass === "small-video" ? "remote-video" : "small-video";
      setLocalVideoClass(localVideoClassvar);
      videoElementIds.forEach(function (id) {
        var element = document.getElementById(id);
        if (element) {
          element.classList.remove("medium-video");
          element.classList.remove(
            localVideoClassvar === "remote-video"
              ? "remote-video"
              : "small-video-remote"
          );
          element.classList.add(
            localVideoClassvar === "remote-video"
              ? "small-video-remote"
              : "remote-video"
          );
        }
      });
    }
  };

  return (
    <>
      <div className="room-page">
        
          <>
          <div className="call-meeting-head">
              <Calling 
                meetingId={RoomId}
                />
            </div>
            <div id="videoGroup" className="video-group">
              <div className="video-container">
                <div
                  id="local-video"
                  onClick={() => changeClasses()}
                  className={`${localVideoClass} ${
                    muteVideo ? "mute-active" : "mute-inactive"
                  } ${callType != "audio-video" ? "audio-active" : ""} `}
                >
                  <span className="yel-parameter">
                    
                    <MdPerson /> {userName} (you)
                  </span>
                  {muteVideo || callType != "audio-video" ? (
                    <div className="circle-outer">
                      <div id="local-circle" className="circle-muted">
                        <span className="text-circle">
                          {capitalizedUserName}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="aud-vid-mute">
                    <div
                      className={`mut-aud ${muteVideo ? "mute-active" : ""}`}
                    >
                      {muteAudio ? <FaMicrophoneSlash /> : <FaMicrophone />}
                    </div>
                    {callType === "audio-video" ? (
                      <div
                        className={`mut-vid ${muteAudio ? "mute-active" : ""}`}
                      >
                        {muteVideo ? <FaVideoSlash /> : <FaVideo />}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {videoElements}

              </div>
            </div>
          </>
        

        <div id="callFooter">
          

          <div
            className={` ${
              !isAdminCreated && callType !== "audio-video"
                ? "footer-video-user"
                : "footer-video"
            }`}
          >
            {callType === "audio-video" ? (
              <>
                <button className="btn-foot mute" onClick={() => muteMicro()}>
                  {muteAudio ? <FaMicrophoneSlash /> : <FaMicrophone />}
                </button>
                <button className="btn-foot video" onClick={() => muteCam()}>
                  {muteVideo ? <FaVideoSlash /> : <FaVideo />}
                </button>
              </>
            ) : (
              <>
               
              </>
            )}

           
              <button
                id="chat-btn"
                className="btn-foot chat"
                onClick={() => openChat()}
              >
                <BsChatDots />
              </button>
           
            {callType !== "audio-video" && !isAdminCreated && (
              <button
                className="btn-foot mute audio-only"
                onClick={() => muteMicro()}
              >
                {muteAudio ? <FaMicrophoneSlash /> : <FaMicrophone />}
              </button>
            )}
            <button
              className="drop-call"
              onClick={() => dropCall()}
            >
              <MdCallEnd />
            </button>
           
          </div>
          <div id="chatBox">
            <IonModal isOpen={chatPopupOpen} className="chat-popup">
              <div className="font-14 flex-space-between">
                <h2>CHAT</h2>
                <IoCloseSharp
                  className="chat-send-icon"
                  onClick={() => setChatPopupOpen(false)}
                />
              </div>
              <div className="chats">
                <div className="chat-body">
                  {messageList.map((message) =>
                    message.type === "sent" ? (
                      <div className="chat-message">
                        <div className="message-right">
                          <div className="message-text">
                            <span className="message-user">{message.name}</span>
                            {message.content}
                            <span className="message-time">{message.time}</span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="chat-message">
                        <div className="message-left">
                          <span className="message-user">{message.name}</span>
                          <div className="message-text">
                            {message.content}
                            <span className="message-time">{message.time}</span>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
              <div className="w-100 flex-space-between mt-10">
                <input ref={sendText} type="text" className="send-text-area1" />
                <LuSendHorizonal
                  className="chat-send-icon"
                  onClick={() => sendMessage()}
                />
              </div>
            </IonModal>
          </div>
          
        </div>
      </div>
    </>
  );
};

export default GroupCall;
